import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './HowDoISignUp.module.css';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
function HowDoISignUp(props) {
    const {history}=props
  return (
    <>
     <div className={css.BusinessWorkWrap}>
      <div className={css.HowDoISignUpMain}>
        <p className={css.heading}>
          {' '}
          <FormattedMessage id="HowDoISignUp.heading" />
        </p>
        <p className={css.subheading}>
          <FormattedMessage id="HowDoISignUp.subHeading" />{' '}
        </p>
        <div className={css.HowDoISignUpContainer1}>
          <div className={css.boxItem}>
            <div className={css.boxItemDescContainer}>
              <h3 className={css.title}>
                <FormattedMessage id="HowDoISignUp.title1" />
              </h3>
              <p className={css.about}>
                <span
                  className={css.about1Span}
                  onClick={e => {
                    e.stopPropagation();
                    history.push(
                      createResourceLocatorString('SignupPage', routeConfiguration(), {}, {})
                    );
                  }}
                >
                  <FormattedMessage id="HowDoISignUp.about1Span" />
                </span>
                <FormattedMessage id="HowDoISignUp.about1" />{' '}
              </p>
            </div>
          </div>
          <div className={css.boxItem}>
            <div className={css.boxItemDescContainer}>
              <h3 className={css.title}>
                {' '}
                <FormattedMessage id="HowDoISignUp.title2" />
              </h3>
              <p className={css.about}>
                <FormattedMessage id="HowDoISignUp.about2" />{' '}
              </p>
            </div>
          </div>
          <div className={css.boxItem}>
            <div className={css.boxItemDescContainer}>
              <h3 className={css.title}>
                {' '}
                <FormattedMessage id="HowDoISignUp.title3" />
              </h3>
              <p className={css.about}>
                <FormattedMessage id="HowDoISignUp.about3" />{' '}
              </p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default compose(withRouter)(HowDoISignUp);
